import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNetworks: [],     
  playlistName: "",
  title: "",
  description: "",
  coverImage: "",
  selectedVideos: [],
  selectedPlaylist: null,
  isFormOpen: false,
};

const playlistSlice = createSlice({
  name: "playlist",
  initialState,
  reducers: {
    setSelectedPlaylist: (state, action) => {
      state.selectedPlaylist = action.payload;
    },
    clearSelectedPlaylist: (state) => {
      state.selectedPlaylist = null;
    },
    toggleForm: (state) => {
      state.isFormOpen = !state.isFormOpen;
    },
    // 👇 nuova action: gestisce array di network ID
    setSelectedNetworks: (state, action) => {
      state.selectedNetworks = action.payload;
    },
    setPlaylistName: (state, action) => {
      state.playlistName = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    setCoverImage: (state, action) => {
      state.coverImage = action.payload;
    },
    setSelectedPlaylistVideos: (state, action) => {
      state.selectedVideos = action.payload;
    },
    addVideoToPlaylist: (state, action) => {
      if (!state.selectedVideos.some((v) => v.id === action.payload.id)) {
        state.selectedVideos.push(action.payload);
      }
    },
    removeVideoFromPlaylist: (state, action) => {
      state.selectedVideos = state.selectedVideos.filter(
        (v) => v.id !== action.payload
      );
    },
    resetPlaylistState: (state) => {
      state.selectedNetworks = [];
      state.playlistName = "";
      state.title = "";
      state.description = "";
      state.coverImage = "";
      state.selectedVideos = [];
      state.selectedPlaylist = null;
    },
  },
});

export const {
  setSelectedNetworks,     
  setPlaylistName,
  setTitle,
  setDescription,
  setCoverImage,
  setSelectedPlaylistVideos,
  addVideoToPlaylist,
  removeVideoFromPlaylist,
  resetPlaylistState,
  setSelectedPlaylist,
  clearSelectedPlaylist,
  toggleForm,
} = playlistSlice.actions;

export default playlistSlice.reducer;
